import React from 'react'
import { Divider, Header, Image, Item } from "semantic-ui-react";

export function getAttachmentType(url) {
  if (typeof url !== 'string') return null
  if (url.match(/\.(jpeg|jpg|gif|png)(\?.*)?$/i) != null) return 'image'
  if (url.match(/\.pdf(\?.*)?$/i) != null) return 'pdf'
  return null
}

function pdfPreviewUrl(url) {
  if (typeof url !== 'string') return url
  const separator = url.includes('#') ? '&' : '#'
  return `${url}${separator}toolbar=0&navpanes=0&scrollbar=0`
}

function shouldRenderInline(attachmentType, showInlineImages, showInlinePdfs) {
  if (attachmentType === 'image') return showInlineImages !== false
  if (attachmentType === 'pdf') return showInlinePdfs !== false
  return false
}

const AttachmentPreview = ({
  href,
  url,
  title,
  attachmentType,
  showInlineImages,
  showInlinePdfs,
  showLinkWhenNotInline = false,
}) => {
  const resolvedType = attachmentType || getAttachmentType(url)
  const inline = shouldRenderInline(resolvedType, showInlineImages, showInlinePdfs)
  const showImage = resolvedType === 'image' && inline
  const showPdf = resolvedType === 'pdf' && inline
  const showLink = showLinkWhenNotInline && (!resolvedType || !inline)

  if (!showImage && !showPdf && !showLink) return null

  return (
    <Item.Content >
      <Divider/>
      {showImage && (
        <Image src={url} size="medium" href={href} target="_blank" rel="noopener noreferrer"/>
      )}
      {showPdf && (
        <div style={{ backgroundColor: '#fff', padding: '0.25rem', width: '30%' }}>
          <div style={{ position: 'relative', width: '100%', aspectRatio: '1 / 1.4142' }}>
            <iframe
              src={pdfPreviewUrl(url)}
              title={title}
              width="100%"
              height="100%"
              style={{ border: 0, backgroundColor: '#fff', colorScheme: 'light', position: 'absolute', inset: 0, pointerEvents: 'none' }}
            />
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={title}
              style={{ position: 'absolute', inset: 0, zIndex: 1 }}
            />
          </div>
        </div>
      )}
      {showLink && (
        <Header size="small" href={href} target="_blank" rel="noopener noreferrer">
          {title}
        </Header>
      )}
    </Item.Content>
  )
}

export default AttachmentPreview
